import { computedClass } from 'utils'
import Icon from 'components/ui/icon/Icon'
import './style.scss'

function FieldLabel({ label, required, labelMark }) {
    if (!label) return null

    const { type, text } = labelMark || {}

    const markClasses = computedClass({
        'field-label__mark': true,
        'field-label__mark--success': type === 'success',
        'field-label__mark--error': type === 'error',
        'field-label__mark--text': text,
    })

    return (
        <label className="field-label">
            <span className="field-label__text">{label}</span>
            {required && <span className="field-label__req-mark">*</span>}
            {labelMark && (
                <div className={markClasses}>
                    {!text && (
                        <Icon name={type === 'success' ? 'check' : 'close'} className="field-label__mark-icon"></Icon>
                    )}
                    {text && <span>{text}</span>}
                </div>
            )}
        </label>
    )
}

export default FieldLabel
